export default __webpack_public_path__ + "static/media/bg_investor.c4613c29.png";